import * as React from "react";
import { useSelector } from "react-redux";

import { canManageApplications } from "store/entities/applications";

import { IntegrationsTab } from "../../constants";

import InReviewApps from "./InReviewApps";
import InstalledApps from "./InstalledApps";
import PrivateApps from "./PrivateApps";

const TabsContent: React.FC<{ selected: string }> = ({ selected }) => {
  const canManageApps = useSelector(canManageApplications);

  switch (selected) {
    default:
    case IntegrationsTab.installed:
      return <InstalledApps />;

    case IntegrationsTab.private:
      return canManageApps && <PrivateApps />;

    case IntegrationsTab.inReview:
      return canManageApps && <InReviewApps />;
  }
};

export default TabsContent;
